import { reactive, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useLoader } from '../useLoader'
import { useError } from '../useError'
import { usePoliticalActions } from './usePoliticalActions'
import { useNotifications } from '@/services/notification/useNotifications'
import { useDialog } from '@/services/useDialog'
import { useLogs } from '@/services/useLogs'
import { useTopData } from '@/services/useHome'
import axios from '@/axios'

const rejectHeaders = reactive([
  { title: '概要', attr: 'overview', comment: '' },
  { title: '備考', attr: 'remarks', comment: '' },
  { title: '画像添付', attr: 'files', comment: '' },
  { title: '資料添付', attr: 'additionalResources', comment: '' },
  { title: 'メッセージ', attr: 'officeMessage', comment: '' },
])

const isRejectBtnEnabled = ref(false)
const rejectedAttrs = reactive([])

export const useResultReject = () => {
  const { toggleShowLoader } = useLoader()
  const { toggleShowError } = useError()
  const route = useRoute()
  const resetResultRejectedItems = () => {
    while (rejectedAttrs.length > 0) {
      rejectedAttrs.pop()
    }
    rejectHeaders.forEach(x => (x.comment = ''))
  }

  const toUnderscoreCase = str => {
    return str
      .split(/(?=[A-Z])/)
      .join('_')
      .toLowerCase()
  }

  const toSnake = () => {
    for (let i = 0; i < rejectedAttrs.length; i++) {
      Object.keys(rejectedAttrs[i]).forEach(function(key) {
        if (key === 'target') {
          rejectedAttrs[i][key] = toUnderscoreCase(rejectedAttrs[i][key])
        }
      })
    }
  }
  let data = reactive({})
  const submitReject = async (id, documentId, type, userRank) => {
    const {
      getActivitiesAfterResponse,
      currentPoliticalAction,
    } = usePoliticalActions()
    const { getNotificationsAfterResponse } = useNotifications()
    const { getTimelineAfterResponse } = useLogs()
    const { getTopDataAfterResponse } = useTopData()
    try {
      toggleShowLoader(true)
      // 会派事務局の時にアップデートを行う
      if (userRank === 2) {
        // fileの送信を行うためformDataオブジェクトを使用する
        const formdata = new FormData()

        // 保存タイプのフラグのフォームデータを作成
        formdata.append('is_temporary', false)
        formdata.append(
          'document_type',
          currentPoliticalAction.report.documentType,
        )

        // 概要ののフォームデータを作成
        if (currentPoliticalAction.report.overview) {
          formdata.append('overview', currentPoliticalAction.report.overview)
        }

        // 備考のフォームデータを作成
        if (currentPoliticalAction.report.remarks) {
          formdata.append('remarks', currentPoliticalAction.report.remarks)
        }

        // 添付資料のフォームデータを作成
        currentPoliticalAction.report.additionalResources.forEach(file => {
          if (file?.display) {
            formdata.append('keep_file_names[]', file.display)
          } else {
            formdata.append('additional_resources[]', file)
          }
        })

        // 画像のフォームデータを作成
        for (let i = 0; i < currentPoliticalAction.report.images.length; i++) {
          Object.keys(currentPoliticalAction.report.images[i]).forEach(key => {
            if (currentPoliticalAction.report.images[i][key]) {
              const keyName = 'images[' + i + '][' + key + ']'
              formdata.append(
                keyName,
                currentPoliticalAction.report.images[i][key],
              )
            }
          })
        }
        // postだとだとマルチパート形式のファイル送信がうまくいかないためputをオーバーライド
        let config = {
          headers: {
            'content-type': 'multipart/form-data',
            'X-HTTP-Method-Override': 'PUT',
          },
        }
        await axios.put(`/actions/${id}`, formdata, config)
      }

      toSnake()
      data = {
        document_id: documentId,
        document_type: type,
        sent_back_items: rejectedAttrs,
      }
      let res = null
      res = await axios.post(`/actions/reject`, data)
      if (route.name === 'Activities') {
        await getActivitiesAfterResponse(res)
      } else if (route.name !== 'Activities') {
        const { closeDialog } = useDialog()
        closeDialog()
        if (route.name === 'Top') {
          await getTopDataAfterResponse(res)
        } else if (route.name === 'Logs') {
          await getTimelineAfterResponse(res)
        } else if (route.name === 'Notifications') {
          await getNotificationsAfterResponse(res)
        }
      }
      toggleShowLoader(false)
    } catch (e) {
      console.log('err', e, e.resuponse)
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  return {
    rejectHeaders,
    rejectedAttrs,
    isRejectBtnEnabled,
    resetResultRejectedItems,
    submitReject,
    toSnake,
  }
}
